<template>
  <div class="alarm-chart" id="alarm-box">
    <div class="homepage-title">
      <el-tooltip class="item" placement="bottom" :open-delay="delay" popper-class="atooltip">
        <div slot="content">硬件告警=硬件告警数量<br />订单告警=异常订单结算数量<br/>网络告警=桩掉线数量+edge掉线数量</div>
        <span class="title-n">告警类型</span>
      </el-tooltip>
      <div style="flex-grow: 3;"></div>
      <div class="right-btn">
        <span :class="[active==1?'active':'']" @click="dateClick(1)">日</span>
        <span>/</span>
        <span :class="[active==2?'active':'']" @click="dateClick(2)">月</span>
      </div>
    </div>
    <div class="chart-box">
      <div style="width:100%;height:100%;" id="alarm2"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      delay:1000,
      HEIGHT:"",
      width:"",
      timer:"",
      active: 1,
      list:{},
      listDay: [],
      listMonth:[],
      data: [],
      type: [],
      total: 0,
    };
  },
  mounted() {
    let o = document.getElementById("alarm-box");
    
    
    this.$nextTick(function() {

       if(this.$store.state.alarmType!=""){
          this.getEchartData();
        }

        // this.getEchartData();
    });
  },
  destroyed(){
    // window.clearTimeout(this.timer)
  },
  watch:{
    
  },
  destroyed(){
    window.onresize = null;
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
  methods: {
    getEchartData() {
      // this.listDay = [];
      // this.listMonth = [];
      // this.total = 0;
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action: "getAlarms"
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret +=
      //           encodeURIComponent(it) +
      //           "=" +
      //           encodeURIComponent(data[it]) +
      //           "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
        let su=this.$store.state.alarmType
          if (su.data.code == 1) {
            
            this.list = su.data.list;
            
            // if(su.data.list.day_hardware == 0 && su.data.list.day_network == 0 && su.data.list.day_order == 0){
            //   this.listDay.push({value:0,name:"硬件告警"});
            //   this.listDay.push({value:0,name:"网络告警"});
            //   this.listDay.push({value:0,name:"订单告警"});
            // } else {
            //   if(su.data.list.day_hardware > 0){
                this.listDay.push({value:su.data.list.day_hardware,name:"硬件告警"});
              // }
              // if(su.data.list.day_network > 0){
                this.listDay.push({value:su.data.list.day_network,name:"网络告警"});
              // }
              // if(su.data.list.day_order > 0){
                this.listDay.push({value:su.data.list.day_order,name:"订单告警"});
            //   }
            // }
            
            // if(su.data.list.month_hardware == 0 && su.data.list.month_network == 0 && su.data.list.month_order == 0){
            //   this.listMonth.push({value:0,name:"硬件告警"});
            //   this.listMonth.push({value:0,name:"网络告警"});
            //   this.listMonth.push({value:0,name:"订单告警"});
            // } else {
              // if(su.data.list.month_hardware > 0){
                this.listMonth.push({value:su.data.list.month_hardware,name:"硬件告警"});
              // }
              // if(su.data.list.month_network > 0){
                this.listMonth.push({value:su.data.list.month_network,name:"网络告警"});
              // }
              // if(su.data.list.month_order > 0){
                this.listMonth.push({value:su.data.list.month_order,name:"订单告警"});
            //   }
            // }
            
            
            this.drawChart(this.listDay,this.list);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        // })
        // .catch(err => {});
    },
    drawChart(data,list) {
      // debugger
      this.total = 0;
      // console.log(list);
      // console.log(data);
      if(this.active == 1){
        this.total = list.day_hardware + list.day_network + list.day_order;
      } else if(this.active == 2){
        this.total = list.month_hardware + list.month_network + list.month_order;
      }
      let echart = echarts.init(document.getElementById("alarm2"));
      var option = {
        tooltip: {
          textStyle: {
            align: "left"
          }
        },
        color: ["#4C8FFF", "#33B869", "#FF7A7B"],
        legend: {
          bottom: 10,
          left: "center",
          // data: this.type,
          itemWidth: 10,             // 图例图形宽度
          itemHeight: 10,
          itemGap: 10,
          textStyle: { color: "#FFFDFE",fontSize:"12px", },
          icon: "circle", //图例形状设置
          formatter:function(name){
            let target;
            for(let i=0;i<data.length;i++){
                if(data[i].name===name){
                    target=data[i].value
                }
            }
            let arr=["{b|"+name+"}"]
            return arr.join("\n")

          },
          textStyle:{
            rich:{
              a:{
                fontSize:10,
                color:"#FFFDFE",
              },
              b:{
                fontSize:10,
                color:"#FFFDFE"
              }
            }
          }
        },
        graphic: [
          //饼图中间数字和文字显示
          {
            type: "text",
            // left: "36%",
            // top: "120px",
            left: "center",
            top: "43%",
            z: 2,
            zlevel: 100,
            style: {
              text: "告警数量",
              fill: "#FFFFFD",
              font: "bold Microsoft YaHei",
              fontSize:14,
            }
          },
          {
            type: "text",
            // left: "45%",
            // bottom: "100px",
            left: "center",
            top: "52%",
            z: 2,
            zlevel: 100,
            style: {
              text: this.total,
              fill: "#5ec9ff",
              fontWeight:700,
              fontSize:26,
            }
          }
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "55%"],
            center: ['50%', '50%'],
            label: {
              normal: {
                textStyle: {
                  color: "#5FC7FE",
                  fontSize: 12
                }
              }
            },
            label: { //饼图线
              normal: {
                formatter: "{b}{per|{c}}\n",
                borderWidth: 20,
                borderRadius: 4,
                padding: [0, -30],
                rich: {
                  a: {
                    fontSize: 10,
                    lineHeight: 20,
                    align: "center"
                  },
                  //                         hr: {
                  //                             width: '100%',
                  //                             height: 4,
                  //                             align:'center'
                  //                         },
                  per: {
                    align: "center",
                    fontSize: 10
                  }
                }
              }
            },
            data: data,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}  \n {c}" //标题换行，按照自己的格式进行配置
                },
                labelLine: {
                  show: true,
                  length:12,
                  length2:30,
                },
                borderWidth: 4, //每个扇形直接留有空隙
                borderColor: "#0C1E2A", //空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          }
        ]
      };
      echart.setOption(option);
      var that=this
      echart.on("click", function (params) {
        if (params.name == "订单告警") {
          that.$router.push("/operationManagement/alarmManagement");
          that.$store.commit("MonthDay",that.active)
          that.$store.commit("AlarmNum",1)
        } else if (params.name == "硬件告警") {
          that.$router.push("/operationManagement/alarmManagement/");
          that.$store.commit("MonthDay",that.active)
          that.$store.commit("AlarmNum",7)
        } else if (params.name == "网络告警") {
          that.$router.push( "/operationManagement/alarmManagement/")
          that.$store.commit("MonthDay",that.active)
          that.$store.commit("AlarmNum",2)
        }
      });
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function (){
          window.onresize = function () {
            echart.resize();
          }
        },0)
      }, 100);
    },
    dateClick(num){
      // debugger
      this.active = num;
      if(num == 1){
        this.drawChart(this.listDay,this.list);
      } else if(num == 2){
        this.drawChart(this.listMonth,this.list);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.alarm-chart {
  width: 100%;
  height: 100%;
  // margin-bottom: 16px;
  position: relative;
  z-index: 1;
  .homepage-title {
    width: 70%;
    display: flex;
    left: 26px;
    .title-n {
      color: #fffffd;
      flex-grow: 1;
    }
  }
  .chart-box {
    width: 100%;
    height: 90%;
    position: absolute;
    bottom: 0;
    // padding-top: 10%;
  }
  .right-btn {
    display: inline-block;
    flex-grow: 1;
    z-index: 999;
    span {
      color: #006EAE;
      cursor: pointer;
    }
    span.active {
      color: #ABE3FE;
    }
  }
}
@media screen and (max-width:1500px){
  .alarm-chart {
    .homepage-title {
      font-size: 12px;
      top:7px;
      left: 17px;
    }
  }
}
</style>
<style>
  .atooltip {
  background:rgba(50,50,50,0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/displayScreen/alarmType.vue